import { RouteConfig } from 'vue-router';

import FeeBase from '@/views/fee/steps/Base.vue';

export function feeBaseRoute(name: string, edit: boolean): RouteConfig {
  const path = `base${edit ? '' : '/:feeId?'}`;
  return {
    name,
    path,
    component: FeeBase,
    meta: {},
    props: { edit }
  };
}
